import React, { useState, useEffect } from "react"

const SgOnlinesInput = ({ selectedTextObj, updateSelectedText }) => {
    const [defaultValue, setDefaultValue] = useState("")

    useEffect(() => {
        console.log(selectedTextObj)
        setDefaultValue(selectedTextObj?.options?.rankIds)
    }, [selectedTextObj])

    if (selectedTextObj?.variable?.key !== "sgOnlines") return

    return (
        <div className="control-section">
            <h3>انلاین های رنک:</h3>
            <div className="style-control">
                <label>ایدی رنک:</label>
                <input
                    type="text"
                    value={defaultValue}
                    placeholder="1,2,3"
                    onChange={(e) => {
                        updateSelectedText("options", {
                            ...selectedTextObj.options,
                            rankIds: e.target.value,
                        })
                    }}
                />
            </div>
            <div style={{ color: "#68b0ab", fontSize: "15px" }}>
                با , میتوانید چند تا رنک تعریف کنید
            </div>
        </div>
    )
}

export default SgOnlinesInput
